<template>
  <div class="login-form">
    <img class="light-pic" :src="loginLightImg" alt="" />
    <span class="title">用户登录</span>
    <el-form :model="loginForm" ref="loginFormRef" class="my-loginForm" :rules="rules">
      <el-form-item prop="account">
        <el-input v-model="loginForm.account" placeholder="请输入账户号" autocomplete="off">
          <c-icon slot="prefix" name="icon-qingshuruzhanghuhao"></c-icon>
        </el-input>
      </el-form-item>
      <el-form-item prop="password">
        <el-input v-model="loginForm.password" type="password" placeholder="请输入密码" show-password
          autocomplete="off">
          <c-icon slot="prefix" name="icon-mima"></c-icon>
        </el-input>
      </el-form-item>
      <el-form-item>
        <el-input v-model="loginForm.captchaCode" placeholder="请输入手机验证码" autocomplete="off" clearable>
          <c-icon slot="prefix" name="icon-mima"></c-icon>
        </el-input>
        <Button size="small" type="primary" style="width: 93px;margin-left: 7px;height: 26px;position: absolute;top: 7px;" :disabled="verify.isSend" @click="showSlideModal">{{ verify.codeName }}</Button>
      </el-form-item>
    </el-form>
    <el-button class="login-btn" type="primary" @click="handleSubmitForm('loginFormRef')">登录
    </el-button>
    <div class="remember-wrap">
<!--      <span class="get">记住登录状态</span>-->
      <span class="forget" @click="goForgetPage">忘记密码?</span>
    </div>
<!--    <div class="choose-wrap">-->
<!--      <span class="label">选择身份</span>-->
<!--      <el-radio-group v-model="identity">-->
<!--        <el-radio :label="0">运营人员</el-radio>-->
<!--        <el-radio :label="1">代理机构</el-radio>-->
<!--      </el-radio-group>-->
<!--    </div>-->
    <div class="go-register" @click="goRegisterPage">
      >>还没有账号，去注册!!
    </div>
  </div>
</template>

<script>
import { getTenantList, oauthToken, fgjToSendPhoneCode } from "@/axios/api/main.js";
import JSEncrypt from "jsencrypt";
import { getBasePrefixUrl } from '@/utils/envBaseUrl.js'

export default {
  props: {},
  components: {},
  data() {
    return {
      verify: {
        isSend: false,
        codeName: '获取验证码',
        totalTime: 60,
        timer: null,
      },
      loginLightImg: require("../image/login-light@2x.png"), // 登录下方向灯
      loginForm: {
        account: "", // 账号
        password: "", // 密码
        captchaCode: '',
      },
      rules: {
        // account: [{ required: true, message: '账号不能为空' }],
        // password: [{ required: true, message: '密码不能为空' }],
      },
      identity: "", // 身份
      validCodeUuid: "",
      user: {
        type: "accountLogin",
        name: localStorage.getItem("userName") || "",
        password: "",
        // validCode: '',
        rememberName: !!localStorage.getItem("userName"),

        tenantCode: "", // 默认为空
        tenantName: "",
        systemCode: "1",
        systemName: "",
        entityType: "",
        entityName: "",
      },
      systemEntity: {
        map: null,
        systemArr: [],
        entityArr: [],
      },
      options: {
        tenantCode: [],
        systemCode: [],
        entityType: [],
      },
      ruleInline: {
        name: [
          {
            required: true,
            message: "不能为空",
            trigger: "blur,change",
          },
        ],
        password: [
          {
            required: true,
            message: "不能为空",
            trigger: "blur,change",
          },
        ],
        tenantCode: [
          {
            required: true,
            message: "请选择区划名称",
            trigger: "blur,change",
          },
        ],
        systemCode: [
          {
            required: true,
            message: "请选择系统类型",
            trigger: "blur,change",
          },
        ],
        entityType: [
          {
            required: true,
            message: "请选择主体类型",
            trigger: "blur,change",
          },
        ],
        // validCode: [util.form.inputRule],
      },
    };
  },
  computed: {
    // validCodeUrl() {
    //     return `/czy-uaa/validate/code/${this.validCodeUuid}`
    // },
  },
  watch: {
    "user.rememberName"() {
      if (!this.user.rememberName) {
        localStorage.removeItem("userName");
      }
    },
  },
  methods: {
    showSlideModal() {
      if(this.loginForm.account === '' || this.loginForm.account === null || this.loginForm.account === undefined) {
          this.$Message.warning('请输入账号')
          return
      }
      if(this.loginForm.password === '' || this.loginForm.password === null || this.loginForm.password === undefined) {
          this.$Message.warning('请输入密码')
          return
      }
      if (this.verify.isSend) return
      this.onSlideSuccess()
    },
    onSlideSuccess() {
      // 设置 60秒禁止再次获取
      this.verify.isSend = true
      this.verify.codeName = this.verify.totalTime + 's后获取'
      this.verify.timer = setInterval(() => {
        this.verify.totalTime--
        this.verify.codeName = this.verify.totalTime + 's后获取'
        if (this.verify.totalTime < 0) {
          clearInterval(this.verify.timer)
          this.verify.codeName = '获取验证码'
          this.verify.totalTime = 60
          this.verify.isSend = false
        }
      }, 1000)
      this.getVerificationCode()
    },
    getVerificationCode() {
        let encryptor = new JSEncrypt();
        let publicKey =
         "MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCqPvlpJjq2wOBQnkZ1oiepyX2lKq/LIjuG+C17Fdd+gsYQTUJbVNLgNcBXtymSAgmllpBc1J3U0Ojf07j58olnb7jMTGRlsBsmFEhNY51pv2KfbHjNfnhvI3Fi6eO1bPmfwj4dIPDJP8c9ChFtWfliwVxF8yFryEtMb3HqLa6w5QIDAQAB";
        encryptor.setPublicKey(publicKey);
        let data = {
            userName: this.loginForm.account,
            password: encryptor.encrypt(this.loginForm.password),
        }
        fgjToSendPhoneCode(data)
        .then((res) => {
            if(res == true) {
                this.$Message.success('验证码发送成功')
            } else {
                this.$Message.warning('验证码发送失败')
            }
        })
        .catch((err) => {
          console.log(err);
          return;
        });
    },
    // 登录
    handleSubmitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          console.log("submitForm");
          // this.$router.push({ path: "/index" });
          this.userLogin();
        }
      });
    },
    async userLogin() {
      // let flag = await util.form.validate("formValidate", this);
      // if (!flag) {
      //   return;
      // }

      // // TODO 国密sm2加密
      // console.log(this.$b.sm2DoEncrypt(this.loginForm.password))
      // %2B
      // MFkwEwYHKoZIzj0CAQYIKoEcz1UBgi0DQgAEnpvlJgOD%2Bz38ESt%2BLpIh2n48QpB13RI%2BW/Ib6dBd1VGkE2K8N2MWGBjycsor0DEGQ%2Bk2EZIbxqzW3RPeZSzUgg==
      // return
      let encryptor = new JSEncrypt();
      let publicKey =
        "MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCqPvlpJjq2wOBQnkZ1oiepyX2lKq/LIjuG+C17Fdd+gsYQTUJbVNLgNcBXtymSAgmllpBc1J3U0Ojf07j58olnb7jMTGRlsBsmFEhNY51pv2KfbHjNfnhvI3Fi6eO1bPmfwj4dIPDJP8c9ChFtWfliwVxF8yFryEtMb3HqLa6w5QIDAQAB";
      encryptor.setPublicKey(publicKey);

      this.$b.removeStorage();

      let params = {
        captchaCode: this.loginForm.captchaCode,
        username: this.loginForm.account,
        password: encryptor.encrypt(this.loginForm.password),
        grant_type: "password",
        deviceId: this.validCodeUuid,
        tenantCode: "797981047752450048",
        systemCode: "1",
        entityType: "2",
      };

      oauthToken(params)
        .then((res) => {
          console.log(res);
          // if (this.user.rememberName) {
          //   localStorage.setItem("userName", this.loginForm.account);
          // }

          // this.$refs.formValidate.resetFields();
          let userInfo = res;
          this.$store.commit("$setState", {
            key: "userInfo",
            value: userInfo,
          });
          this.$store.commit("$setState", {
            key: "systemEntity",
            value: this.systemEntity,
          });
          this.$store.commit("$setState", {
            key: "options",
            value: this.options,
          });
          localStorage.setItem("token", res.access_token);
          localStorage.setItem("userInfo", JSON.stringify(userInfo));
          localStorage.setItem(
            "systemEntity",
            JSON.stringify(this.systemEntity)
          );
          localStorage.setItem("options", JSON.stringify(this.options));
          // 登录信息 更换主体类型/区划-重登录用 TODO 后期需调整 理论不该用账号密码
          localStorage.setItem("reloginInfo", JSON.stringify(params));
          this.baseFun(); // 获取平台基础信息
        })
        .catch((err) => {
          console.log(err);
          return;
        });
    },
    // 跳转忘记密码页面
    goForgetPage() {
      this.$router.push({ path: "/forgetpass" });
    },
    // 跳转注册页面
    goRegisterPage() {
      this.$router.push({ path: "/register" });
    },
    tenantCodeChange(e) {
      if (!e) {
        return;
      }
      this.user.tenantName = e.label;
      // 区划切换 重新初始化系统、主体类型
      this.initSystemCodeAndEntityType();
    },
    getSystemItem(e) {
      if (!e) {
        return;
      }
      this.user.systemName = e.label;
      // 主体类型
      let entityTypeArr = this.systemEntity.map[e.value];
      this.options.entityType = this.systemEntity.entityArr.filter((item) =>
        entityTypeArr.some((ele) => ele === item.value)
      );
    },
    getEntityItem(e) {
      if (!e) {
        return;
      }
      this.user.entityName = e.label;
    },
    getValidCode() {
      this.validCodeUuid = Date.now();
    },
    async getAllOptions() {
      this.options.tenantCode = await this.getTenantCodeOptions(); // 所有区划
      this.systemEntity.systemArr = await this.$b.selectOptions(
        "systemRootCode"
      ); // 所有系统类型
      this.systemEntity.entityArr = await this.$b.selectOptions(
        "roleGroupCode"
      ); // 所有主体类型

      this.user.tenantCode = this.options.tenantCode[0].value; // 默认取第一个
      this.user.tenantName = this.options.tenantCode[0].label;
      this.initSystemCodeAndEntityType();
    },
    async initSystemCodeAndEntityType() {
      this.systemEntity.map = await this.$b.getEntityTenantMap(
        this.user.tenantCode
      ); // 区划对应的 系统/主体map
      // 系统类型
      let systemCodeArr = [];
      for (let key in this.systemEntity.map) {
        systemCodeArr.push(key);
      }
      this.options.systemCode = this.systemEntity.systemArr.filter((item) =>
        systemCodeArr.some((ele) => ele === item.value)
      );
      // 主体类型
      let entityTypeArr = this.systemEntity.map[systemCodeArr[0]];
      this.options.entityType = this.systemEntity.entityArr.filter((item) =>
        entityTypeArr.some((ele) => ele === item.value)
      );
    },
    async getTenantCodeOptions() {
      let list = [];

      await getTenantList({})
        .then((res) => {
          console.log(res);
          res.forEach((i) => {
            if (i.enable === "1") {
              list.push({
                value: i.tenantCode,
                label: i.tenantName,
              });
            }
          });
        })
        .catch((err) => {
          console.log(err);
          return;
        });
      return list;
    },
    async baseFun() {
      await this.$b.createMenuList(); // 只获取当前平台的权限信息
      await this.$b.setTreeList(); //  获取完整资源树

      window.location.href = getBasePrefixUrl() + "trade/"
      // if (this.$route.query.next) {
      //   this.$router.push({
      //     path: this.$route.query.next,
      //   });
      // } else {
      //   if (this.$store.state.menu.routeList.length > 0) {
      //     this.$router.push({
      //       path: this.$store.state.menu.routeList[0],
      //     });
      //   } else {
      //     this.$Message.warning("没有权限");
      //   }
      // }
    },
    keyDown(e) {
      if (e.keyCode === 13) {
        this.userLogin();
      }
    },
    userRegister() {
      this.$router.push({
        path: "/register",
      });
    },
  },
  mounted() {
    this.getValidCode();
    // this.getAllOptions()
    window.addEventListener("keydown", this.keyDown);
  },
  destroyed() {
    window.removeEventListener("keydown", this.keyDown, false);
  },
};
</script>

<style lang="less" scoped>
.login-form {
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  padding: 98px 221px 0px 199px;
  display: flex;
  flex-direction: column;
  position: relative;
  @media (max-width: 1600px) {
    padding: 98px 122px 0px 99px;
    .light-pic {
      width: 81px !important;
      height: 187px !important;
      position: absolute;
      top: 0px;
      right: 40px !important;
      z-index: 1;
    }
  }
  .light-pic {
    width: 101px;
    height: 237px;
    position: absolute;
    top: 0px;
    right: 59px;
    z-index: 1;
  }
  .title {
    height: 42px;
    font-size: 30px;
    font-weight: 400;
    line-height: 34px;
    color: #4184f4;
    margin-bottom: 49px;
  }
  ::v-deep .my-loginForm {
    .el-form-item {
      height: 42px;
      width: 300px;
      .el-form-item__content {
        input {
          height: 42px;
          font-size: 16px;
          padding-left: 46px;
          &::placeholder {
            color: #ccc;
            font-size: 16px;
          }
        }
        .el-input__prefix {
          left: 20px;
          i {
            font-size: 20px;
          }
        }
      }
    }
  }
  .login-btn {
    width: 100%;
    height: 50px;
    background-color: #4184f4;
    border-color: #4184f4;
    font-size: 16px;
    font-weight: 400;
    color: #ffffff;
    margin-top: 38px;
  }
  .remember-wrap {
    display: flex;
    align-items: center;
    //justify-content: space-between;
    justify-content: flex-end;
    margin-top: 10px;
    margin-bottom: 38px;
    .get {
      height: 20px;
      font-size: 14px;
      font-weight: 400;
      color: #999999;
    }
    .forget {
      height: 20px;
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #4184f4;
      color: var(--primary-color);
      cursor: pointer;
    }
  }
  .choose-wrap {
    display: flex;
    flex-direction: row;
    align-items: center;
    .label {
      margin-right: 22px;
      height: 22px;
      line-height: 22px;
      font-size: 16px;
      font-weight: 400;
      color: #333333;
    }
    ::v-deep .el-radio-group {
      height: 22px;
      display: flex;
      align-items: center;
      .el-radio {
        margin-bottom: 0px;
        font-size: 16px;
        font-weight: 400;
        color: #666666;
      }
    }
  }
  .go-register {
    margin-top: 20px;
    text-align: center;
    height: 20px;
    font-size: 14px;
    font-weight: 400;
    color: #4184f4;
    color: var(--primary-color);
    cursor: pointer;
  }
}
</style>
